declare var process : {
  env: {
    API_URL: string,
    NODE_ENV: string,
  }
}

export const API_URL = process.env.API_URL || '/api/'
export const DEBUG = (process.env.NODE_ENV == 'production')
